import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import router from '../router/index'
import { Message } from 'element-ui'
import utils from './utils'

Vue.use(VueAxios, axios)
axios.defaults.baseURL = '//zb-api.zma-smart.com'
axios.defaults.withCredentials = true

// http 请求 拦截器

axios.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      const data = qs.parse(config.data)
      const token = utils.getStorage('userProfile') ? utils.getStorage('userProfile').token : ''
      config.data = qs.stringify({
        token: token,
        languageCode: window.localStorage.getItem('languageCode') || 'zh_cn',
        v: Math.random(),
        ...data
      })
    } else if (config.method === 'get') {
      config.params = {
        languageCode: window.localStorage.getItem('languageCode') || 'zh_cn',
        v: Math.random(),
        ...config.params
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  },
)

// http 响应 拦截器
axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      if (res.data.status) {
        return Promise.resolve(res.data)
      } else {
        switch (res.data.errorCode) {
          case '401':case '402': case '20014': case 'loan_audit_50000028': case 'loan_audit_50000029': case 'loan_audit_50000030':
            utils.removeStorage('userProfile')
            router.currentRoute.path !== '/' &&
            router.replace({
              path: '/',
              query: { redirect: router.currentRoute.name }
            })
            return Promise.resolve(res.data)
          case '404':
            router.push('/404')
            break
          case '500':
            // router.push("/500")
            break
          default:
            return Promise.resolve(res.data)
        }
      }
    }
  },
  err => {
    Message.error(err.message)
  },
)
